export default __webpack_public_path__ + "static/media/PlayersManagementarImageTwo.0230d4a2.png";